import * as Config from '../../../../config';
import React from 'react';
import PropTypes from 'prop-types';

import GridFull from './GridFull';
import Card from '../../common/Card';
import CardLoading from '../../common/CardLoading';
import Spinner from '../../common/Spinner';

import useReleases from '../../../../hooks/useReleases';
import useNCReleases from '../../nav-control/hooks/useNCReleases';

function GridReleases(props) {
  const { id, pathApi, width, rowCount, perPage, showLoading, filtersConfig } = props;
  const perPageCal = perPage ?? Math.floor(width / Config.CARD_WIDTH) * rowCount;
  const [dataHook] = useReleases(id, pathApi, perPageCal);
  const customFiltersConfig = filtersConfig ? filtersConfig : [`release_name`, `artists_s`, `remixers_s`, `label`, `publish_date`, 'preorders'];

  useNCReleases(id, (dataHook && dataHook.items) ? dataHook.items : null);

  return (dataHook && dataHook.itemsFull && dataHook.itemsFull.length > 0)
    ? <GridFull
        {...props}
        gutter={{ top: 4, left: 4, width: 8 }}
        dataHook={dataHook}
        filtersConfig={customFiltersConfig}
        element={ <Card /> }
        loadingElement={ <CardLoading /> }
      />
    : (showLoading ? <Spinner /> : null)
}

GridReleases.propTypes = {
  id: PropTypes.string.isRequired,
  width: PropTypes.any,
  height: PropTypes.number.isRequired,
  title: PropTypes.string,
  pathApi: PropTypes.string.isRequired,
  hasFilters: PropTypes.bool,
  filtersStyle: PropTypes.object,
  forceHeight: PropTypes.number,
  rowCount: PropTypes.number,
  rowHeight: PropTypes.number,
  columnCount: PropTypes.number,
  hasPagination: PropTypes.bool,
  perPage: PropTypes.number,
  allTo: PropTypes.any,
  style: PropTypes.object,
  showLoading: PropTypes.bool
}

// function propsAreEqual(prev, next) {
//   return prev.styleGridReleasesArrowLeft === next.styleGridReleasesArrowLeft;
// }
// export default React.memo(GridReleases, propsAreEqual); // IF BAD PERFORMANCE REMOVE

export default GridReleases;